const ROUTE_PATH = {
  ROOT: '/',
  HOME: '/home',
  ORCH_DOC: '/orchestrator',
  ORCH_DOC_ASYNC: '/orchestrator_async',
  ORCH_DOC_SYNC: '/orchestrator_sync',
  ORCH_LIST_SERVICES_ASYNC: '/list_services_async',
  ORCH_LIST_SERVICES_SYNC: '/list_services_sync',
}

const SERVICE_TYPE_ASYNC = 'ASYNC'
const SERVICE_TYPE_SYNC = 'SYNC'

export {
  ROUTE_PATH,
  SERVICE_TYPE_ASYNC,
  SERVICE_TYPE_SYNC,
}
